<script lang="ts">
	import Card from '@smui/card';
	import Select, { Option } from '@smui/select';
	import { _ } from 'svelte-i18n';
	import StepWizard from 'svelte-step-wizard';
	import { writable } from 'svelte/store';
	import ContainerLoading from '../../../..//shared/components/common/Loading/ContainerLoading.svelte';
	import FieldLoading from '../../../..//shared/components/common/Loading/FieldLoading.svelte';
	import FormLoading from '../../../..//shared/components/common/Loading/FormLoading.svelte';
	import TitleCard from '../../../..//shared/components/common/Title.svelte';
	import CalcoloEmissioni from '../../../../shared/models/PSCL/Elaborazione/CalcoloEmissioni';
	import PSCLElaborazione from '../../../../shared/models/PSCL/Elaborazione/PSCLElaborazione';
	import { isNumeric } from '../../../../shared/validators';
	import { hasRoleAreaManager, hasRoleCompanyManager } from './../../../../shared/stores';
	import StimulsoftReport from '../../../../shared/components/common/StimulsoftReport.svelte';

	export let params = {
		id: '0',
	};

	let previousPsclElaborazioneId = 0;
	let percorrenzaMedia = 0;
    let loadingPercorrenza = false;

	let [data, loading, error] = CalcoloEmissioni.get(params.id);
	let [dataPSCLElaborazione, loadingPSCLElaborazione, errorPSCLElaborazione] = PSCLElaborazione.getList();
	let [dataSubmit, loadingSubmit, errorSubmit] = [null, null, null];
	let [dataReport, loadingReport, errorReport] = [null, writable(true), null];

	var alimentazioniCarSharing = ['Benzina e/o gasolio', 'Metano e/o GPL', 'Ibrida', 'Elettrica', 'Mista'];
	var alimentazioniScooterSharing = ['Benzina', 'Elettrica', 'Mista'];
	var alimentazioniNavette = ['Gasolio', 'Metano', 'Ibrida', 'Elettrica'];

	let selectedPSCLElaborazione: PSCLElaborazione | undefined = undefined;
	$: selectedPSCLElaborazione = $dataPSCLElaborazione?.response?.find(psclElaborazione => psclElaborazione.id === $data.psclElaborazioneId);

	$: if ($dataSubmit && !$loadingSubmit) {
		$data = $dataSubmit;
		[dataReport, loadingReport, errorReport] = CalcoloEmissioni.report($data);
	}

	function submit() {
		[dataSubmit, loadingSubmit, errorSubmit] = CalcoloEmissioni.save($data);
	}

	async function calcolaPercorrenzaMedia() {
		loadingPercorrenza = true;
		try {
			const result = await CalcoloEmissioni.calcolaPercorrenzaMedia($data);
			if (result && result.response) {
				percorrenzaMedia = result.response;
			}
		} catch (error) {
			console.error("Errore nel calcolo della percorrenza media:", error);
		} finally {
			loadingPercorrenza = false;
		}
	}
	
	$: if ($data.psclElaborazioneId > 0 && $data.psclElaborazioneId !== previousPsclElaborazioneId) {
		previousPsclElaborazioneId = $data.psclElaborazioneId;
		calcolaPercorrenzaMedia();
	}
</script>

<Card class="md:px-8 md:py-8" padded>
	<div class="flex justify-between">
		<TitleCard title="Benefici ambientali" />
	</div>
	{#if $loading}
		<FormLoading customClass="pt-8" />
	{:else}
		<StepWizard initialStep="{1}">
			<StepWizard.Step num="{1}" let:nextStep>
				<div class="grid grid-cols-1 px-4 pt-4">
					<div class="flex col-start-2" style="text-align: end">
						<button disabled="{$data.psclElaborazioneId == 0}" type="button" class="btn-white h-14 w-14 sm:h-16 sm:w-16" on:click="{nextStep}">
							<span class="material-icons-outlined text-2xl leading-[3rem] sm:text-3xl sm:leading-[3.25rem]">arrow_forward_ios</span>
						</button>
					</div>
				</div>
				<span class="p-4">  Seleziona l'elaborazione PSCL e premi avanti per continuare con il calcolo dei benefici ambientali.</span>
				<div class="md:grid-cols-3 grid grid-cols-1">
					{#if $loadingPSCLElaborazione}
						<FieldLoading customClass="md:col-start-2" />
					{:else}
						<Select
							disabled="{!$hasRoleCompanyManager}"
							label="Elaborazione PSCL"
							key="{(psclElaborazione) => `${(psclElaborazione && psclElaborazione?.id) || ''}`}"
							class="md:col-start-2 w-full"
							bind:value="{selectedPSCLElaborazione}"
							required
						>
							{#if $dataPSCLElaborazione.response}
								{#each $dataPSCLElaborazione.response as psclElaborazione (psclElaborazione?.id)}
									{#if psclElaborazione?.descrizione}
										<Option
											value="{psclElaborazione}"
											on:click="{() => {
												$data.psclElaborazione = psclElaborazione;
												$data.psclElaborazioneId = psclElaborazione.id;
											}}">{psclElaborazione.descrizione}</Option
										>
									{/if}
								{/each}
							{/if}
						</Select>
					{/if}
				</div>
			</StepWizard.Step>
			<StepWizard.Step num="{2}" let:previousStep let:nextStep>
				<div class="grid grid-cols-2 p-4">
					<div class="justify-self-start col-start-1">
						<button type="button" class="btn-white h-14 w-14 sm:h-16 sm:w-16" on:click="{previousStep}">
							<span class="material-icons-outlined text-2xl leading-[3rem] sm:text-3xl sm:leading-[3.25rem]">arrow_back_ios</span>
						</button>
					</div>
					<div class="justify-self-end col-start-2">
						<button
							type="button"
							class="btn-white h-14 w-14 sm:h-16 sm:w-16"
							on:click="{() => {
								submit();
								nextStep();
							}}"
						>
							<span class="material-icons-outlined text-2xl leading-[3rem] sm:text-3xl sm:leading-[3.25rem]">calculate</span>
						</button>
					</div>
				</div>
				
				<!-- Istruzioni e percorrenza media prima della tabella -->
				<div class="mb-6">
					<p class="text-gray-700">
						Nella tabella seguente, occorre inserire i valori di input per il calcolo dei benefici ambientali. 
						Se hai bisogno di aiuto per scegliere i valori da inserire, consulta la guida o chiedi al chatbot.
					</p>
					
					{#if loadingPercorrenza}
						<div class="flex items-center mt-2">
							<div class="border-b-transparent animate-spin w-4 h-4 mr-2 border-2 border-blue-500 rounded-full"></div>
							<p>Calcolo percorrenza media in corso...</p>
						</div>
					{:else if percorrenzaMedia > 0}
						<p class="mt-2 text-gray-700">
							Inoltre, il valore riportato di seguito può essere utilizzato come percorrenza media per il calcolo dei benefici, 
							riducendolo adeguatamente per modalità come la bicicletta, per le quali si suppone che il dipendente abiti più vicino alla sede.
						</p>
						<p class="mt-2 font-bold">
							Percorrenza media degli automobilisti (da questionario): {percorrenzaMedia} km (sola andata)
						</p>
					{/if}
				</div>
				<div class="flex flex-col">
					<div class="sm:-mx-6 lg:-mx-8 xl:overflow-x-visible -my-2 overflow-x-auto">
						<div class="sm:px-6 lg:px-8 inline-block min-w-full py-2 align-middle">
							<div class="overflow-x-hidden">
								<table class="min-w-full p-0 m-0 text-sm leading-10 border-t-4 border-collapse border-black table-auto">
									<thead>
										<tr class="p-1">
											<th scope="col" class="border-b p-2.5 text-center text-xs leading-6 tracking-wider">Modalità</th>
											<th scope="col" class="border-b p-2.5 text-center text-xs leading-6 tracking-wider"
												>N° di automobilisti che si prevede cambino modalità</th
											>
											<th scope="col" class="border-b p-2.5 text-center text-xs leading-6 tracking-wider"
												>Distanza media di percorrenza sola andata [km/singolo spostamento]</th
											>
											<th scope="col" class="border-b p-2.5 text-center text-xs leading-6 tracking-wider"
												>Operatività delle misure [giorni/anno]</th
											>
											<th scope="col" class="border-b p-2.5 text-center text-xs leading-6 tracking-wider">Alimentazione</th>
											<th scope="col" class="border-b p-2.5 text-center text-xs leading-6 tracking-wider"
												>N° viaggi [viaggi/giorno]</th
											>
											<th scope="col" class="border-b p-2.5 text-center text-xs leading-6 tracking-wider"
												>Percorrenze [km/viaggio]</th
											>
										</tr>
									</thead>
									<tbody>
										{#each $data.modalitaCalcoloEmissioni as modalitaCalcoloEmissioni}
											{#if $hasRoleCompanyManager}
												<tr class="odd:bg-white even:bg-gray-50 p-1">
													<td class="border-b p-2.5 text-center leading-5">{modalitaCalcoloEmissioni.modalita}</td>
													<td
														contenteditable="true"
														on:keypress="{isNumeric}"
														class="border-b p-2.5 text-center leading-5"
														bind:innerHTML="{modalitaCalcoloEmissioni.nAutomobilistiCambiamentoModalitaPrevisto}"></td>
													<td
														contenteditable="true"
														on:keypress="{isNumeric}"
														class="border-b p-2.5 text-center leading-5"
														bind:innerHTML="{modalitaCalcoloEmissioni.distanzaMediaPercorrenzaAndata}"></td>
													<td
														contenteditable="true"
														on:keypress="{isNumeric}"
														class="border-b p-2.5 text-center leading-5"
														bind:innerHTML="{modalitaCalcoloEmissioni.operativitaMisure}"></td>
													<td class="border-b p-2.5 text-center leading-5">
														{#if modalitaCalcoloEmissioni.modalita.toLowerCase() == 'car sharing' || modalitaCalcoloEmissioni.modalita.toLowerCase() == 'scooter sharing' || modalitaCalcoloEmissioni.modalita.toLowerCase() == 'navette'}
															<Select bind:value="{modalitaCalcoloEmissioni.alimentazione}">
																{#if modalitaCalcoloEmissioni.modalita.toLowerCase() == 'car sharing'}
																	{#each alimentazioniCarSharing as alimentazione}
																		<Option value="{alimentazione}">{alimentazione}</Option>
																	{/each}
																{:else if modalitaCalcoloEmissioni.modalita.toLowerCase() == 'scooter sharing'}
																	{#each alimentazioniScooterSharing as alimentazione}
																		<Option value="{alimentazione}">{alimentazione}</Option>
																	{/each}
																{:else if modalitaCalcoloEmissioni.modalita.toLowerCase() == 'navette'}
																	{#each alimentazioniNavette as alimentazione}
																		<Option value="{alimentazione}">{alimentazione}</Option>
																	{/each}
																{/if}
															</Select>
														{:else}
															-
														{/if}
													</td>
													{#if modalitaCalcoloEmissioni.modalita.toLowerCase() == 'navette'}
														<td
															contenteditable="true"
															on:keypress="{isNumeric}"
															class="border-b p-2.5 text-center leading-5"
															bind:innerHTML="{modalitaCalcoloEmissioni.nViaggi}"></td>
														<td
															contenteditable="true"
															on:keypress="{isNumeric}"
															class="border-b p-2.5 text-center leading-5"
															bind:innerHTML="{modalitaCalcoloEmissioni.percorrenze}"></td>
													{:else}
														<td class="border-b p-2.5 text-center leading-5">-</td>
														<td class="border-b p-2.5 text-center leading-5">-</td>
													{/if}
												</tr>
											{:else if $hasRoleAreaManager}
												<tr class="odd:bg-white even:bg-gray-50 p-1">
													<td class="border-b p-2.5 text-center leading-5">{modalitaCalcoloEmissioni.modalita}</td>
													<td class="border-b p-2.5 text-center leading-5"
														>{modalitaCalcoloEmissioni.nAutomobilistiCambiamentoModalitaPrevisto}</td
													>
													<td class="border-b p-2.5 text-center leading-5"
														>{modalitaCalcoloEmissioni.distanzaMediaPercorrenzaAndata}</td
													>
													<td class="border-b p-2.5 text-center leading-5">{modalitaCalcoloEmissioni.operativitaMisure}</td>
													<td class="border-b p-2.5 text-center leading-5"
														>{modalitaCalcoloEmissioni.alimentazione ?? '-'}</td
													>
													{#if modalitaCalcoloEmissioni.modalita.toLowerCase() == 'navette'}
														<td class="border-b p-2.5 text-center leading-5">{modalitaCalcoloEmissioni.nViaggi}</td>
														<td class="border-b p-2.5 text-center leading-5">{modalitaCalcoloEmissioni.percorrenze}</td>
													{:else}
														<td class="border-b p-2.5 text-center leading-5">-</td>
														<td class="border-b p-2.5 text-center leading-5">-</td>
													{/if}
												</tr>
											{/if}
										{/each}
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
			</StepWizard.Step>
			<StepWizard.Step num="{3}" let:previousStep>
				<div class="p-4">
					{#if $loadingReport}
						<ContainerLoading />
					{:else if !$loadingReport && $dataReport}
						<div class="mb-6">
							<h2 class="mb-4 text-xl font-bold">Benefici ambientali connessi all'adozione dello smart working:</h2>
							<ul class="pl-8 list-disc">
								<li>{$dataReport.smartWorkingNOx.toLocaleString('it-IT', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} kg/anno di NOx</li>
								<li>{$dataReport.smartWorkingPM10.toLocaleString('it-IT', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} kg/anno di PM10</li>
								<li>{$dataReport.smartWorkingCO2.toLocaleString('it-IT', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} tonnellate/anno di CO2</li>
							</ul>
						</div>
						
						{#if $dataReport && $dataReport.modalitaReportEmissioni && $dataReport.modalitaReportEmissioni.length > 0}
							<StimulsoftReport
								urlFile="./assets/reports/ReportEmissioni.mrt.html"
								dataSetName="ReportEmissioni"
								bind:data="{$dataReport}"
							/>
						{:else}
							<div class="p-4 text-center bg-yellow-100 border border-yellow-400 rounded">
								<p>Nessun dato disponibile per generare il report completo.</p>
							</div>
						{/if}
					{/if}
				</div>
			</StepWizard.Step>
		</StepWizard>
	{/if}
</Card>
